export default {
  affiliate: {
    // Main navigation
    title: 'Afiliado',
    cantFindQuestion: '¿No encuentras la pregunta?',
    onlineService: 'Servicio en línea',
    dashboard: 'Panel de control',
    myRewards: 'Mis Recompensas',
    // My Price 页（照 Figma 重做）
    team: 'Team',
    myPrice: 'My Price',
    rule: 'Rule',
    checkOutRules: 'Check Out Our Rules',
    rewardsOverview: 'Rewards Overview',
    rewardAmount: 'Reward Amount',
    date: 'Date',
    selectDate: 'Select Date',
    commissionRewards: 'Commission Rewards',
    noReferralRewards: 'No referral rewards yet \nInvite friends to start earning rewards',
    noCommissionRewards: 'No commission rewards yet \nStart earning by inviting friends',
    inviteFriendsToEarnTitle: 'Invite Friends To Earn',
    moreFriendsMoreRewards: 'More friends, more rewards, unlimited earning potential !',
    inviteNow: 'Invite Now',
    invitationRewards: 'Recompensas de Invitación',
    rules: 'Reglas',

    // Team Info
    teamData: 'Datos del Equipo',
    details: 'Detalles',
    totalValidFriends: 'Total de amigos válidos:',
    todayTotalWager: 'Apuesta total de hoy:',
    rewards: 'Recompensas',

    // Commission rates
    inviteFriendsCommissionUpTo: 'Comisión por Invitar Amigos Hasta',
    expandTeamBonus: 'Bono de Expansión de Equipo',
    maxLevelCommission: 'Comisión de Nivel Máximo',
    inviteFriendsCommission: 'Comisión por Invitar Amigos',
    maxPerformanceCommission: 'Comisión de Rendimiento Máximo',
    unlimitedAgent: 'Agente Ilimitado',
    unlimitedCommission: 'Comisión Ilimitada',
    commissionRate: 'Tasa de Comisión',

    // Team Invite Friends
    inviteFriendsToEarn: 'INVITA AMIGOS PARA GANAR',
    link: 'Enlace',
    code: 'Código',
    inviteFriends: 'Invitar amigos',
    share: 'Compartir',

    // Withdrawal Rewards
    totalCommission: 'Total Commission',
    claim: 'Reclamar',
    bettingBonus: 'Betting Bonus',
    depositBonus: 'Deposit Bonus',
    todayReceived: 'Recibido Hoy',
    
    liveRewards: 'Live Rewards',
    sendTotalCommission: 'Enviar comisión total',

    // Team Data Details
    totalRewardsReceived: 'Total Commission',
    todayInviteFriends: 'Amigos Invitados Hoy',
    todayDepositFriends: 'Amigos con Depósito Hoy',
    depositFriends: 'Amigos con Depósito',
    validFriends: 'Amigos Válidos',

    // Dialogs
    shareInvitationLink: 'Comparte tu enlace de invitación para que se registren.',
    shareInvitationCode: 'Comparte tu código de invitación para que lo introduzcan durante el registro.',
    shareQRCode: 'Comparte tu código QR para que lo escaneen y se registren.',

    // Share Dialog
    shareTitle: 'Compartir',
    player: 'Jugador',
    saveImage: 'Guardar imagen',
    saveImageSuccess: "Imagen guardada",
    saveImageFailed: "Error al guardar, inténtalo de nuevo",
    copy: 'Copiar',
    copied: '¡Copiado!',

    // Received/Withdraw
    received: 'Recibido',
    withdraw: 'Retirar',
    history: 'Historial',
    referralRewards: 'Recompensas de Referencia',
    commission: 'Comisión',
    depositRebate: 'Reembolso de Depósito',
    levelUpRewards: 'Recompensas de Subida de Nivel',
    loading: 'Cargando...',
    noMoreRecords: 'No hay más registros',
    loadMore: 'Cargar más',
    pending: 'Pendiente',
    paid: 'Pagado',
    rejected: 'Rechazado',
    unknown: 'Desconocido',
    upgradeReward: 'Recompensa por Subir de Nivel',
    cancelled: 'Cancelado',
    receiving: 'Recibiendo',
    failed: 'Falló',
    expired: 'Expirado',

    // History Dialog
    pickDate: 'Selecciona una fecha',
    select: 'Seleccionar',
    chooseBonus: 'Elegir bono',
    all: 'Todos',

    // Invitation Rewards Page
    yourFriendGet: 'Tu amigo obtiene',
    dailyInvitations: 'Invitaciones diarias',

    // Rules - How to earn
    howToEarnAffiliateRewards: '¿Cómo ganar recompensas de afiliado?',
    shareToFriends: 'Compartir con amigos',
    shareReferralLink: 'Comparte tu enlace de referencia, código o código QR con tus amigos',
    friendsSignUpDeposit: 'Los amigos se registran y depositan',
    inviteFriendsRegisterDeposit: 'Invita a amigos a registrarse en AFUN y realizar un primer depósito.',
    getUpTo: 'Obtén hasta',
    earnBigRewards: 'Gana recompensas y comisiones cuando tus amigos apuesten, depositen y alcancen VIP.',
    noticeEnsureCorrect: 'Aviso: Asegúrate de que el enlace de invitación, código QR o código sea correcto.',

    // Rules - Commission Work
    howCommissionWork: '¿Cómo funciona la Comisión?',
    agentRatingDescription: 'Descripción de Calificación de Agente',
    you: 'TÚ',
    commissionDescription: 'Gana una comisión de los depósitos y apuestas de tus Amigos B, C, D y más allá. Consulta la tabla de la derecha para conocer las tasas de comisión.',
    claimConditions: 'Condiciones de reclamación',
    teamLevel: 'Nivel del Equipo',
    earnUpTo: "Earn up to",
    expandYourTeam: "Amplía Tu Equipo",
    earnAnExtra: "Gana un Extra",
    upgradeAgentLevel: "Sube Tu Nivel de Agente",
    todayValidFriends: "Today valid friends",
    inviteFriendsAndEarn: "INVITE FRIENDS AND EARN",
    joinUsGetCommission: "Join us and get more commission",
    shareLinkInviteDesc: "Share the link with your friends and invite them to register and deposit, you and your friend can get shared commissions.",
    totalSize: 'Tamaño Total',
    teamWager: 'Apuesta del Equipo',
    rebateRewardVary: 'La Recompensa de Reembolso y la Recompensa de Recarga varían según el nivel de tu Equipo ese día.',
    teamSizeDescription: 'Tamaño del equipo: El número de usuarios válidos que tienes actualmente.',
    teamBettingDescription: 'Apuestas del equipo: El número total de apuestas que tus subordinados realizan en un día.',
    teamCommissionTitle: 'TEAM COMMISSION\n\nEarn from every deposit and every bet across your network.',
    teamCommissionMainTitle: 'COMISIÓN DE EQUIPO',
    teamCommissionSubTitle: 'Gana con cada depósito y\ncada apuesta de tu red.',
    friendsBettingRebate: 'Friends betting rebate commission',
    commissionCalcEvery24h: 'The system calculates commissions every 24 hours.',
    earnCommissionWhenBet: 'You earn a commission when your friends or their friends place bets.',
    commissionSameIpRule: 'Commissions cannot be released to accounts that share the same IP address, device, or shared account, regardless of whether they are on public networks (such as schools, libraries, and offices) or private networks (such as homes and apartments). To receive commissions, the referred account must be on a unique IP address, not shared with other accounts on the platform.',
    commissionFormula: 'Commission = total team wager * 1% * commission rate.',
    commissionRangeDescription: 'You can receive a certain percentage of commission from all the wager and recharge amount made by A, B, C, D, E and F. Please refer to the following diagram for specific commission rates.',
    commissionSupportGames: 'Commission Support Games',

    // Rules - Invitation Rewards
    inviteFriendsBothReceive: 'Invita amigos y ambos recibirán recompensas',
    inviteRegisterReceive: 'Invita con éxito a amigos a registrarse y recibe',
    friendDepositWagerUnlock: 'Cuando tu amigo deposite 10.00 USDT y apueste 50.00 USDT, desbloqueas una recompensa de 3.00 USDT y tu amigo obtiene 2.00 USDT.',
    inviteFriendToGet: 'Invita a un amigo para obtener',
    inviteFriendsEarnRewards: 'Invita amigos y gana recompensas',
    howMakeFriendsSubordinates: 'Cómo hacer que los amigos sean tus subordinados:',
    howMakeFriendsValidUsers: 'Cómo hacer que tus amigos se conviertan en usuarios válidos:',
    successfullyInviteFriends: 'Invita con éxito a amigos a registrarse.',
    cumulativeDepositsReach: 'Sus depósitos acumulados alcanzan 10.00 USDT.',
    cumulativeValidBetsReach: 'Sus apuestas válidas acumuladas alcanzan 50.00 USDT.',
    thenBecomeValidUsers: 'Entonces, se convertirán en usuarios válidos.',
    depositFriendsDescription: 'Cuando tus amigos subordinados depositen dinero con éxito, se convertirán en amigos que depositan.',

    // Team Data Dialog / Rewards 补充
    recentInviteFriends: 'Amigos Invitados Recientes',
    recentDepositFriends: 'Amigos con Depósito Recientes',
    today: 'Hoy',
    yesterday: 'Ayer',
    thisMonth: 'Este mes',
    friendsData: 'Datos de Amigos',
    joinDate: 'Fecha de Ingreso',
    search: 'Buscar',
    level: 'Nivel',
    tier: 'Nivel',
    affiliateTreasureBox: 'Cofre del Tesoro de Afiliados',
    referralRewardsDesc: 'Cuando invitas a amigos a registrarse, tanto tú como tus amigos recibirán generosas bonificaciones.',
    commissionDesc: 'Tú y tu equipo trabajan juntos para alcanzar sus objetivos y ganar generosas comisiones.',
    affiliateTreasureBoxDesc: 'Invita amigos para obtener bonos por hitos',
  }
};
